<template>
  <div>
    <SettingsNavigation />

    <div
      class="max-w-screen-xl mx-auto sm:grid sm:grid-cols-2 sm:gap-x-6 px-6"
    >
      <AboutCard />
      <LogoCard />
    </div>
  </div>
</template>

<script>
import AboutCard from '@components/Settings/Branding/AboutCard'
import SettingsNavigation from '@components/Settings/SettingsNavigation'
import LogoCard from '@components/Settings/Branding/LogoCard'

export default {
  components: {
    AboutCard,
    LogoCard,
    SettingsNavigation
  }
}
</script>
